// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Team from "./team.js"
import User from "./user.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": null,
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "user_id": {
      "column": {
        "default": null,
        "name": "user_id",
        "null": false,
        "type": "uuid"
      },
      "name": "user_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "TeamApplication",
  "collectionKey": "team_applications",
  "collectionName": "team_applications",
  "i18nKey": "team_application",
  "camelizedLower": "teamApplication",
  "name": "TeamApplication",
  "nameDasherized": "team-application",
  "pluralName": "team_applications",
  "ransackable_associations": [
    {
      "className": "Competition",
      "collectionName": "competitions",
      "foreignKey": "competition_id",
      "name": "competition",
      "macro": "has_one",
      "resource_name": "Competition",
      "through": "team"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "owners",
      "macro": "has_many",
      "resource_name": "User",
      "through": "team"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "team",
      "macro": "belongs_to",
      "resource_name": "Team",
      "through": null
    },
    {
      "className": "TeamUser",
      "collectionName": "team_users",
      "foreignKey": "team_user_id",
      "name": "team_user",
      "macro": "belongs_to",
      "resource_name": "TeamUser",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_team_id",
      "column": {
        "default": null,
        "name": "old_team_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_team_user_id",
      "column": {
        "default": null,
        "name": "old_team_user_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_user_id",
      "column": {
        "default": null,
        "name": "old_user_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "state",
      "column": {
        "default": null,
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "team_id",
      "column": {
        "default": null,
        "name": "team_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "team_user_id",
      "column": {
        "default": null,
        "name": "team_user_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "user_id",
      "column": {
        "default": null,
        "name": "user_id",
        "null": false,
        "type": "uuid"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "team",
      "macro": "belongs_to",
      "resource_name": "Team",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    }
  ],
  "paramKey": "team_application",
  "primaryKey": "id"
}

/** Frontend model for TeamApplication. */
export default class TeamApplication extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {string} */
  userId() {
    return this.readAttributeUnderscore("user_id")
  }

  /** @returns {boolean} */
  hasUserId() {
    const value = this.userId()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  accept(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "accept",
        primaryKey: this.primaryKey(),
        collectionName: "team_applications",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  cancel(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "cancel",
        primaryKey: this.primaryKey(),
        collectionName: "team_applications",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  decline(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "decline",
        primaryKey: this.primaryKey(),
        collectionName: "team_applications",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./team.js").default | null} */
  team() {
    return this._readBelongsToReflection({modelClass: Team, reflectionName: "team"})
  }

  /** @returns {Promise<import("./team.js").default | null>} */
  loadTeam() {
    if (!("teamId" in this)) throw new Error("Foreign key method wasn't defined: teamId")

    const id = this.teamId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "team",
        model: this,
        modelClass: Team
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./team.js").default | null>} */
  ensureTeamLoaded() {
    return this.ensureAssociationLoaded("team")
  }

  /** @returns {import("./user.js").default | null} */
  user() {
    return this._readBelongsToReflection({modelClass: User, reflectionName: "user"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadUser() {
    if (!("userId" in this)) throw new Error("Foreign key method wasn't defined: userId")

    const id = this.userId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "user",
        model: this,
        modelClass: User
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  ensureUserLoaded() {
    return this.ensureAssociationLoaded("user")
  }
}
